import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=66e2f6d2&scoped=true&"
var script = {}
import style0 from "./Video.vue?vue&type=style&index=0&id=66e2f6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2f6d2",
  null
  
)

export default component.exports